export const TASK_REQUEST= 'TASK_REQUEST';
export const POST_TASK_SUCCSESS= 'POST_TASK_SUCCSESS';
export const GET_TASK_SUCCSESS= 'GET_TASK_SUCCSESS';
export const UPDATE_TASK_SUCCSESS= 'UPDATE_TASK_SUCCSESS';
export const DELETE_TASK_SUCCSESS= 'DELETE_TASK_SUCCSESS';
export const TASK_ERROR= 'TASK_ERROR';